"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("ComposeUI/redux/ActionTypes"));

var _constants = require("ComposeUI/lib/constants");

var _UserSettings = _interopRequireDefault(require("ComposeUI/data/model/UserSettings"));

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _UserSettings.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_USER_SETTINGS_PENDING:
      return state.set('status', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.FETCH_USER_SETTINGS_SUCCEEDED:
      return _UserSettings.default.fromJS(action.data);

    case _ActionTypes.default.FETCH_USER_SETTINGS_FAILED:
      return state.set('status', _constants.RequestStatus.FAILED);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;